<template>
  <div>
    <h5
      class="ui header"
      style="text-align: center;text-decoration:underline"
    >
      Add note to current visit
    </h5>
    <div class="ui form">
      <div class="field">
        <label for="note">Note</label>
        <textarea
          name=""
          id=""
          rows="4"
          placeholder="Note"
          v-model="note"
        />
      </div>
      <div class="field">

        <div 
          class="ui blue fluid button"
          @click="setVisitNote()"
        >
          Save visit
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      note: null
    }
  },
  methods: {
    setVisitNote() {
      this.$emit('visit-note', {
        data: { note: this.note }
      })
    }
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/rooms/room_components/visits_popup_components/VisitDetail.vue